export enum DocumentType {
  ID_CARD = "ID_CARD",
  PASSPORT = "PASSPORT",
  DRIVERS_LICENSE = "DRIVERS_LICENSE",
  BIRTH_CERTIFICATE = "BIRTH_CERTIFICATE",
  VISA = "VISA",
  OTHER = "OTHER",
}

export interface Document {
  id: string;
  guestId: string;
  fileId: string;
  type: DocumentType;
  isApproved: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDocumentDto {
  bookingId: string;
  guestId: string;
  fileId: string;
  type: DocumentType;
}

export interface CreateDocumentResponse {
  message: string;
  document: Document;
}
